import { Box } from "@mui/material";
import { useRef, type ReactNode } from "react";
import { useRuntimeLayoutFullscreenMenu } from "./useRuntimeLayoutFullscreenMenu.js";

type RuntimeLayoutFullscreenShellProps = {
  children?: ReactNode;
};

/**
 * Stable viewport shell for public/runtime layout pages.
 *
 * Fullscreen is requested on this container so disconnecting the websocket or
 * temporarily losing the layout document does not unmount the fullscreen target.
 */
export function RuntimeLayoutFullscreenShell({
  children,
}: RuntimeLayoutFullscreenShellProps) {
  const shellRef = useRef<HTMLDivElement>(null);
  const { handleOpenRuntimeContextMenu, contextMenu } =
    useRuntimeLayoutFullscreenMenu(shellRef, false);

  return (
    <Box
      ref={shellRef}
      onContextMenu={handleOpenRuntimeContextMenu}
      sx={{
        width: "100vw",
        height: "100vh",
        position: "fixed",
        inset: 0,
        overflow: "hidden",
        margin: 0,
        padding: 0,
        backgroundColor: "transparent",
      }}
    >
      {children}
      {contextMenu}
    </Box>
  );
}
